(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderTorRuleController', LenderTorRuleController);

    LenderTorRuleController.$inject = ['lenderId', 'rules'];

    function LenderTorRuleController(lenderId, rules) {
        var vm = this;

        vm.lenderId = lenderId;
        vm.rules = rules;
    }
})();
